<template>
  <div :class="{'is-active': showLoading}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div class="xlevel">
            <div class="xlevel-item">
              <div class="loading-status">Loading...</div>
              <div class="xxxlevel-item">
                <!-- <i class="fas fa-spinner fa-pulse"></i> -->
                 <img src="\Preloader_5.gif" width="166">
                <!-- <progress class="progress is-large is-info" max="90">60%</progress> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageLoading',
  data() {
    return {
    };
  },
  methods: {},
  computed: {},
  props: {
    showLoading: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-background {
  opacity: 0.75;
}
.modal-content {
  max-width: 280px;
  font-size: 28px;
  color: #0F3D80;
}
.modal-content-box {
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.21);
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.modal-content-wrapper {
  padding: 25px 25px;
}

@media only screen and (max-width: 768px) {

}

</style>
